<template lang='pug'>
  include /mixins
  +b.tt-space_mt--5(
    :class='{ "has-additional-filters-space": needSearch }'
  )
    row.g-row--appearance_column-reverse-till-xl.g-row--appearance_reverse-xl.g-row--appearance_spaced(
      :justify='"between-xl"'
    ).relative
      .cell-content(
        :class='{"tt-space_mt tt-space_mt--10-xl": needSorting }'
      )
        div(
          :class='{"cell-content__wrapper": needSorting || !needSorting && needSearch}'
        )
          ui-loader(v-if='loading')
          catalog-content(
            :loading="loading"
            :items="result && result.data"
            :pagination="pagination"
            @update:pagination="changePagination"
            :url='initbaseUrl'
          )
            template(#before)
              slot(name='before')
            slot
      aside.cell-sidebar
        catalog-sidebar(
          space="xl"
          :filters="filters"
          @update:filters="changeFilters"
          :pagination="pagination",
          :attributesResource='attributesResource',
          :availableAttributesResource='availableAttributesResource',
          :needPrices='needPrices'
          :needSorting='needSorting'
          :needTitle='needTitle'
          :sortlist='sortlist'
          :needSearch='needSearch'
          @category-hack='$emit("category-hack")'
          :label='label'
          :kwargs='kwargs'
          :needBlocking='needBlocking'
          :initbaseUrl='initbaseUrl'
          :tabs='tabs'
          :isselectsort='isselectsort'
        )
</template>

<script>

import CatalogSidebar from './Sidebar'
import CatalogContent from './Content'

export default {
  components: { CatalogSidebar, CatalogContent },
  props: [
    'result',
    'loading',
    'receive',
    'parameters',
    'filters',
    'changeFilters',
    'pagination',
    'changePagination',
    'attributesResource',
    'availableAttributesResource',
    'needPrices',
    'needSorting',
    'needTitle',
    'needSearch',
    'label',
    'sortlist',
    'selector',
    'needBlocking',
    'initbaseUrl',
    'kwargs',
    'tabs',
    'isselectsort',
  ],

  created() {
    // this.search()
  },

  methods: {
    search() {
      this.receive(this.parameters)
    },
  },
}

</script>
